<template>
  <div>
    <version1 v-if="version == 1"></version1>
    <version2 v-if="version == 2"></version2>
<!--    <version-ciicshared v-if="version == 3"></version-ciicshared>-->
  </div>
</template>

<script>

import version1 from '../index/index.vue'
import version2 from '../index2/index.vue'
import versionCiicshared from '../CIICSharedHRConsultancy/index.vue';

export default {
  name: 'codelogin',
  components: {version1, version2, versionCiicshared},
  data() {
    return {
      version: ''
    }
  },
  created() {
    if (this.$route.query.sign && this.$route.query.userid) {
      this.version = 3;
      localStorage.setItem('version', 3);
    } else {
      this.version = localStorage.getItem('version');
    }
  }
}
</script>


